import { renderEmpty } from './render-empty'

export default renderEmpty
